export * from './MenuMoreInfoRestaurantAddress';
